module.exports = __webpack_public_path__ + "static/media/logocln.6d510aeb.png";